import { useQuery } from "react-query";
import { parseMacroData } from "../helpers/parsers";
import { MACRO_KEY } from "../optics/defaults";

const fetchMacroData = () => {
  return new Promise((resolve) => {
    window.AP.confluence.getMacroData((macroData) => {
      if (!Object.keys(macroData || {}).length) {
        resolve(undefined);
        return;
      }

      try {
        if (macroData.macro === MACRO_KEY.CARDS) {
          resolve({
            data: JSON.parse(macroData.data),
            macro: MACRO_KEY.CARDS,
          });
        } else {
          const data = parseMacroData({ data: macroData });
          resolve(data);
        }
      } catch (error) {
        console.log("error", error);
        resolve(undefined);
      }
    });
  });
};

export const useMacroDataQuery = (options = {}) => {
  return useQuery({
    queryKey: ["macroData"],
    queryFn: fetchMacroData,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
    retry: false,
    ...options,
  });
};
